import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import Footer from './Footer';

export default function AboutUs() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col min-h-screen">
      <Header onSearch={() => {}} />
      
      <div className="flex-1 bg-[#1a1625] pt-16">
        <div className="sticky top-16 bg-[#13111d] border-b border-gray-800 z-40">
          <div className="container mx-auto px-4">
            <div className="flex items-center h-12">
              <Link to="/" className="flex items-center space-x-2 text-white hover:text-purple-400">
                <ArrowLeft className="w-5 h-5" />
                <span>{t('common.about_us')}</span>
              </Link>
            </div>
          </div>
        </div>
        
        <main className="container mx-auto px-4 py-8">
          <div className="bg-[#13111d] rounded-lg p-8 text-white">
            <h1 className="text-3xl font-bold mb-6">{t('about.title')}</h1>
            
            <div className="space-y-8">
              <section>
                <p className="text-gray-300 leading-relaxed">
                  {t('about.description')}
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">
                  {t('about.highlight_feature_title')}
                </h2>
                <p className="text-gray-300 leading-relaxed">
                  {t('about.highlight_feature_desc')}
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">
                  {t('about.for_developers_title')}
                </h2>
                <p className="text-gray-300 leading-relaxed">
                  {t('about.for_developers_desc')}
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">
                  {t('about.vision_title')}
                </h2>
                <p className="text-gray-300 leading-relaxed">
                  {t('about.vision_desc')}
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">
                  {t('about.contact_us_title')}
                </h2>
                <p className="text-gray-300 leading-relaxed">
                  {t('about.contact_us_desc')}
                </p>
              </section>
            </div>
          </div>
        </main>
      </div>

      <Footer />
    </div>
  );
} 